// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "." + {"139":"ebb081c5fd0326ae","301":"55107fde0affb45e","470":"a791f6aaa0e11890","537":"5a645c9727e22eda","538":"e631dd8a10719606","646":"120e26959f6d7237","873":"441d49440bc61515","918":"3b514be171a29043"}[chunkId] + ".js";
};